import { fireErrorAnalytics } from '@atlassian/jira-errors-handling';
import { performGetRequest, performPostRequest } from '@atlassian/jira-fetch';
import type { UsersAndRolesDifferenceResponse } from '../../../../common/types';

const getStakeholders = (cloudId: string) =>
	performPostRequest<UsersAndRolesDifferenceResponse>(
		`/gateway/api/jsm/ops/web/${cloudId}/v1/users/roles/filter`,
		{
			body: JSON.stringify({
				limit: '10',
				offset: 0,
				roles: ['Stakeholder'],
			}),
		},
	).catch((err) => {
		fireErrorAnalytics({
			meta: {
				id: 'getStakeholders',
				packageName: 'jiraEocChangeboarding',
				teamName: 'alexstrasza',
			},
			error: err,
			sendToPrivacyUnsafeSplunk: true,
		});
		// throw err;
	});

const getUsersWithoutAdminRole = (cloudId: string) =>
	performGetRequest<UsersAndRolesDifferenceResponse>(
		`/gateway/api/jsm/ops/web/${cloudId}/v1/users/permissionDifference/admin`,
	).catch((err) => {
		fireErrorAnalytics({
			meta: {
				id: 'getUsersWithoutAdminRole',
				packageName: 'jiraEocChangeboarding',
				teamName: 'alexstrasza',
			},
			error: err,
			sendToPrivacyUnsafeSplunk: true,
		});
		throw err;
	});

const getUsersWithoutCustomRole = (cloudId: string) =>
	performGetRequest<UsersAndRolesDifferenceResponse>(
		`/gateway/api/jsm/ops/web/${cloudId}/v1/users/permissionDifference/customRole`,
	).catch((err) => {
		fireErrorAnalytics({
			meta: {
				id: 'getUsersWithoutCustomRole',
				packageName: 'jiraEocChangeboarding',
				teamName: 'alexstrasza',
			},
			error: err,
			sendToPrivacyUnsafeSplunk: true,
		});
		throw err;
	});

export { getUsersWithoutAdminRole, getUsersWithoutCustomRole, getStakeholders };
